import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import memoizeOne from 'memoize-one';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/core';
import { RemoveRedEye as ViewIcon } from '@material-ui/icons';
import { FHETable } from 'data/components';
import renderEnvComponent from 'data/common/renderEnvComponent';
import getSelectors from '../selectors';

class TableStatsProducts extends Component {
    static propTypes = {
        classes: PropTypes.object.isRequired,
        openModal: PropTypes.func.isRequired,
        profile: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired,
        homeProducts: PropTypes.array.isRequired,
    };

    navigateToDetail = rowData => {
        const { history } = this.props;
        return history.push({
            pathname: `/${history.environment}/products/${rowData.homeId}/${rowData.productType}/${rowData.productIdentifier}`,
        });
    };

    renderActions = memoizeOne(profile => {
        const { history, openModal } = this.props;
        const userRights = profile.getIn(['user_rights', history.environment], []);
        let actions = {
            row: [],
            toolbar: [],
        };
        if (profile.get('admin') || userRights.includes('productsDetails')) {
            actions.row.push({
                icon: ViewIcon,
                onClick: ({ label, product_identifier, code }) => {
                    let productCode = code ? code : '0';
                    openModal(label, product_identifier, productCode);
                },
                tooltip: Translator.translate(`general.showDetail`),
            });
        }
        return actions;
    });

    renderColumns = memoizeOne(() => {
        return [
            {
                title: 'Label',
                name: 'label',
            },
            {
                title: Translator.translate('general.table.column.identifier'),
                name: 'product_identifier',
            },
            {
                title: 'Code',
                name: 'code',
            },
        ];
    });

    render() {
        const { homeProducts, profile, history } = this.props;

        return (
            <FHETable
                idTable="homeStatsProducts"
                columns={this.renderColumns()}
                data={homeProducts}
                actions={this.renderActions(profile)}
                minified
                emptyDataSourceMessage={Translator.translate(`generic.products.table.body.emptyDataSourceMessage`)}
            />
        );
    }
}
function mapStateToProps(state, props) {
    const { history } = props;
    const selectors = getSelectors(history.environment);
    return {
        profile: selectors.getProfile(state),
    };
}

const styles = theme => ({
    associated: {
        color: theme.palette.success.main,
    },
    dissociated: {
        color: theme.palette.error.main,
    },
    connected: {
        color: theme.palette.success.main,
    },
    disconnected: {
        color: theme.palette.error.main,
    },
});

export default withRouter(
    renderEnvComponent('scenes/Home/tables/TableHomeProducts', connect(mapStateToProps)(withStyles(styles, { withTheme: true })(TableStatsProducts))),
);



// WEBPACK FOOTER //
// ./environments/genericEnv/scenes/Home/tables/TableStatsProducts.js